import apiCall, { makeUrl } from "../../utils/apiCall";

export function* spoof({ localUserId }) {
  const spoofCall = yield apiCall();
  yield spoofCall.post(makeUrl("/admin/spoof"), {
    localUserId,
  });
  window.location.href = "/"; //eslint-disable-line
}
